var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"primary--text",attrs:{"small":_vm.small,"color":_vm.color,"outlined":""},on:{"click":_vm.goToChangelog}},[_c('v-icon',{attrs:{"small":_vm.small,"left":""}},[_vm._v("mdi-source-branch")]),_vm._v(" "+_vm._s(_vm.VERSION)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }